<template>
    <div class="layout-comment-bottom-bar dsp-flex">
        <div class="layout-cbb-item" v-bind:class="{'layout-cbb-item-cur': curSubTab == 0}" @click="clickPiPan">
            <span>我的批盘</span>
        </div>
        <!-- <div class="layout-cbb-item"><span class="hide">命主反馈</span></div> -->
        <!-- <div class="layout-cbb-item"><span class="hide">反馈对照</span></div> -->
        <div class="layout-cbb-item" v-bind:class="{'layout-cbb-item-cur': curSubTab == 4}" @click="clickOtherPiPan">
            <span>他人批盘</span>
            <span v-if="otherCommentList.length > 0" class="num" v-bind:class="{'num-long': otherCommentList.length > 99}">{{otherCommentList.length > 99 ? '99+' : otherCommentList.length}}</span>
        </div>
    </div>
</template>

<script>
import { SHARE } from '../../modules/share';
import { DATA } from '../../modules/data';
import { COMMENT_DOM } from '../../modules/dom';
export default {
    name: 'CommentBottomBar',
    computed: {
        fromEmbedded() {
            return this.$store.state.embedded.fromEmbedded;
        },
        curSubTab() {
            return this.$store.state.comment.curSubTab;
        },
        otherCommentList() {
            return this.$store.state.othercomment.otherCommentList;
        }
    },
    methods: {
        clickPiPan() {
            if(this.curSubTab == 0) { return; }
            this.$store.state.comment.curSubTab = 0;
            var me = this;
            var personInfo = this.$store.state.detail.personInfo;
            var fullPath = this.$router.history.current.fullPath;
            console.log('clickPiPan-----', personInfo, this.fromEmbedded)
            // return;
            // 先重置，再初始化mini命盘的数据
            this.$store.dispatch("minifatefortune/resetMiniData");
            this.$store.dispatch('minifatefortune/initCommentMiniFateFortune', personInfo);
            this.$store.dispatch('comment/resetData');
            if(this.fromEmbedded) {
                this.$store.dispatch('comment/initEmbeddedPiPan', {
                    detailData: personInfo,
                    cb: function() {
                        // 处理嵌入式批盘页面的跳转
                        var newPath = fullPath.replace('othercomment', 'comment');
                        me.$router.replace(newPath);
                        setTimeout(() => {
                            COMMENT_DOM.updateCommentFormStyle();
                        }, 300);
                    }
                });
            }else {
                this.$store.dispatch('comment/initPiPan', {
                    detailData: personInfo,
                    cb: function() {
                        // 页面跳转
                        if(!me.fromEmbedded){
                            me.$router.replace('/comment/detail/' + personInfo.id);
                            SHARE.initConfigShare();
                            COMMENT_DOM.updateCommentFormStyle();
                        }
                    }
                });
            }
        },
        clickOtherPiPan() {
            if(this.curSubTab == 4) { return; }
            this.$store.state.comment.curSubTab = 4;

            // 处理嵌入式批盘页面的跳转
            var fullPath = this.$router.history.current.fullPath;
            var newPath = fullPath.replace('comment', 'othercomment');
            if(this.fromEmbedded) {
                this.$router.replace(newPath);
                COMMENT_DOM.updateCommentFormStyle();
                return;
            }

            // 页面跳转
            var me = this;
            setTimeout(() => {
                me.$router.replace('/othercomment');
                if(!this.fromEmbedded){
                    SHARE.initConfigShare();
                    COMMENT_DOM.updateCommentFormStyle();
                }
            }, 10);
        }
    }
}
</script>